import { 
    TableHead, TableRow, Table, TableCell, FormControlLabel, Checkbox, 
    TableBody, 
    IconButton
} from '@material-ui/core';
import * as React from 'react';
import { useEffect } from 'react';
import useStyles from 'src/app/maintenance/assets/styles';
import { hasUserPermission } from 'src/app/permission';
import { EditIconLarge, TrashIcon } from 'src/components/Icons';

export const ApiTable = (props) => {
    const classes = useStyles()
    return (
        <Table className={classes.tableContainer} style={{border:props.border ? '1px solid #E2E5ED' : 'none', width:'100%'}}>
            <TableHead>
                <TableRow style={{backgroundColor:'white'}}>
                    {props.isSelect &&  <TableCell style={{ width: '5%' }}>
                        <FormControlLabel
                            label=""
                            style={{marginLeft:'5px'}}
                            control={
                                <Checkbox
                                    style={{ padding: "0px" }}
                                    color="primary"
                                    inputProps={{ "aria-label": "primary checkbox" }}
                                    checked={
                                        props.selectedData.some(entry => entry.fileName === props.data[props.fileIndex].source) &&
                                        props.selectedData.find(entry => entry.fileName === props.data[props.fileIndex].source).apis.length === props.data.length
                                    }
                                    indeterminate={
                                        props.selectedData.some(entry => entry.fileName === props.data[props.fileIndex].source) &&
                                        props.selectedData.find(entry => entry.fileName === props.data[props.fileIndex].source).apis.length > 0 &&
                                        props.selectedData.find(entry => entry.fileName === props.data[props.fileIndex].source).apis.length < props.data.length
                                    }
                        
                                />
                            }
                            onChange={() =>props.handleSelectAll(props.fileIndex)}
                            labelPlacement="start"
                        />
                    </TableCell>
                    }
                   
                    <TableCell style={{ width: !props.isAction ? '15%' : '20%' }}>Path</TableCell>
                    <TableCell style={{ width: !props.isAction ? '35%' : '35%' }}>Description</TableCell>
                    <TableCell style={{ width: !props.isAction ? '20%' : '20%' }}>Base URL</TableCell>
                    <TableCell style={{ width: !props.isAction ? '25%' : '15%' }}>Authentication Token</TableCell>
                    {props.isAction && <TableCell style={{ width: '10%' }}>Action</TableCell>}
                </TableRow>
            </TableHead>
            <TableBody>
                {props.data.map((data, index) => {
                    const isSelected = props.selectedData && props.selectedData.some(entry => 
                        entry.fileName === data.source && 
                        entry.apis.some(api => api.apiName === data.apiName));
                    
                    const authTokenWithDisabled = React.isValidElement(data.authenticationToken) 
                        ? React.cloneElement(data.authenticationToken, {
                            disabled: !isSelected
                        })
                        : data.authenticationToken;
                    return ( 
                        <TableRow key={index} style={{backgroundColor : index % 2 == 0 ? '#F5F5F5' : 'white'}}>
                            {props.isSelect && <TableCell style={{ width: '5%', verticalAlign:'top' }}>
                                <FormControlLabel
                                    label=""
                                    style={{marginLeft:'5px'}}
                                    control={
                                        <Checkbox
                                            style={{ padding: "0px" }}
                                            color="primary"
                                            inputProps={{ "aria-label": "primary checkbox" }}
                                            onChange={() =>props.handleSelectApi(props.fileIndex,index)}
                                            checked={
                                                props.selectedData.some(entry => entry.fileName === data.source) &&
                                                props.selectedData.find(entry => entry.fileName === data.source).apis.some(api => api.apiName === data.apiName)
                                            }
                                        />
                                    }
                                    labelPlacement="start"
                                />
                            </TableCell>
                            }
                            <TableCell className={classes.apiTableCell} style={{ width: !props.isAction ? '15%' : '20%' }}>{data.apiName || 'N/A'}</TableCell>
                            <TableCell className={classes.apiTableCell} style={{ width: !props.isAction ? '35%' : '35%' }}>{data.description || 'N/A'}</TableCell>
                            <TableCell className={classes.apiTableCell} style={{ width: !props.isAction ? '20%' : '20%' }}>{data.serverUrl || 'N/A'}</TableCell>
                            <TableCell className={classes.apiTableCell} style={{ width: !props.isAction ? '25%' : '15%' }}>{authTokenWithDisabled || 'N/A'}</TableCell>
                            {props.isAction && 
                                <TableCell style={{ width: '10%', verticalAlign:'top' }}>
                                    {hasUserPermission("KNOWLEDGE_BASE_UPLOADS.API_INPUT", "EDIT") &&
                                        <IconButton size={'small'} onClick={() => props.handlePopup('edit',data)}>
                                            <EditIconLarge />
                                        </IconButton>
                                    }
                                    {hasUserPermission("KNOWLEDGE_BASE_UPLOADS.API_INPUT", "DELETE") &&
                                        <IconButton size={'small'} onClick={() => props.handlePopup('delete',data)}>
                                            <TrashIcon />
                                        </IconButton>
                                    }
                                </TableCell>}
                        </TableRow>
                    );
                })}
            </TableBody>
        </Table>
    );
};
